import React from "react";
import PropTypes from "prop-types";
import { formatNumber } from "../../utils/utils";

const TextRows = ({ rows }) => {
  if (!rows || rows.length === 0) {
    return <div>Keine Daten verfügbar</div>;
  }

  return (
    <div className="text-rows max-w-xs sm:max-w-md mx-auto">
      {rows.map((row, index) => (
        <div key={index} className="mb-2 text-center">
          <p className="font-semibold text-sm sm:text-base text-black">
            {row.value >= 0 ? "+" : ""} {formatNumber(row.value)} {row.unit}
          </p>
          <p className="text-xs sm:text-sm text-gray-600">({row.year})</p>
        </div>
      ))}
    </div>
  );
};


TextRows.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      unit: PropTypes.string.isRequired,
      year: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default TextRows;